import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { PatientDetails } from './BookingView';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { he, enUS } from 'date-fns/locale';

interface DetailsViewProps {
  customerDetails: PatientDetails;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  selectedDate: Date;
  selectedTime: string;
  showEmailField?: boolean;
}

const DetailsView: React.FC<DetailsViewProps> = ({ customerDetails, onChange, onSubmit, selectedDate, selectedTime, showEmailField }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'he';
  const locale = i18n.language === 'he' ? he : enUS;

  return (
    <div className="p-4">
      <p><strong>{t('date')}:</strong> {selectedDate && format(selectedDate, 'EEEE, d MMMM yyyy', { locale })}</p>
      <p><strong>{t('time')}:</strong> {selectedTime}</p>

      <Form onSubmit={onSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>{t('name')}</Form.Label>
          <Form.Control type="text" name="name" className={`bg-secondary bg-opacity-25 text-light form-control ${isRtl ? 'ms-2' : 'me-2'}`} value={customerDetails.name} onChange={onChange} required />
        </Form.Group>

        {showEmailField && (
          <Form.Group className="mb-3">
            <Form.Label>{t('email')}</Form.Label>
            <Form.Control type="email" name="email" className={`bg-secondary bg-opacity-25 text-light form-control ${isRtl ? 'ms-2' : 'me-2'}`} value={customerDetails.email} onChange={onChange} required />
          </Form.Group>
        )}

        <Form.Group className="mb-3">
          <Form.Label>{t('phone')}</Form.Label>
          <Form.Control type="tel" name="phone" className={`bg-secondary bg-opacity-25 text-light form-control ${isRtl ? 'ms-2' : 'me-2'}`} value={customerDetails.phone} onChange={onChange} required />
        </Form.Group>
 
        <Form.Group className="mb-3">
          <Form.Label>{t('comments')}</Form.Label>
          <Form.Control as="textarea" rows={4} style={{ height: '6rem' }}  name="comments" className={`bg-secondary bg-opacity-25 text-light form-control ${isRtl ? 'ms-2' : 'me-2'}`} value={customerDetails.comments} onChange={onChange} />
        </Form.Group>

        <Button type="submit" className="mt-3">{t('book-appointment')}</Button>
        
        {/* 
        //add billing
        <Button type="submit" className="mt-3">{t('book-pay')}</Button>
        <div className="d-flex align-items-center mt-2">
          <i className={`mdi mdi-credit-card ${isRtl ? 'ms-2' : 'me-2'}`}></i>
          <span>{t('confirm-after-payment')}</span>
        </div> 
        */}

      </Form>
    </div>
  );
};

export default DetailsView;
